"use client";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

import { repairServerSession } from "./repairServerSession";

export function SessionRepairContainer({ fallbackHref }: { fallbackHref?: string }) {
  const router = useRouter();
  const [status, setStatus] = useState<"idle" | "repairing" | "repaired" | "failed">("idle");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setStatus("repairing");
      const ok = await repairServerSession();
      if (cancelled) return;
      if (ok) {
        setStatus("repaired");
        // refresh server component tree
        router.refresh();
      } else {
        setStatus("failed");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [router]);

  return (
    <div className="mt-6 p-4 rounded border bg-muted text-foreground">
      {status === "repairing" && <p>Re-establishing your session…</p>}
      {status === "failed" && (
        <div className="space-y-3">
          <p>
            We couldn&apos;t restore your session automatically. You can try again or start over.
          </p>
          <div className="flex gap-3">
            <button
              className="px-3 py-2 rounded bg-primary text-white"
              onClick={async () => {
                setStatus("repairing");
                const ok = await repairServerSession();
                if (ok) router.refresh();
                else setStatus("failed");
              }}
            >
              Try again
            </button>
            {fallbackHref && (
              <a className="px-3 py-2 rounded border" href={fallbackHref}>
                Start over
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
